(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3770],{

/***/ 17876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Img_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53068);
/* harmony import */ var _Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Img_module_scss__WEBPACK_IMPORTED_MODULE_3__);






// import { LazyImage } from 'react-lazy-images';

// eslint-disable-next-line react/prop-types
var Img = function(_param) {
    var className = _param.className, wrapperClassName = _param.wrapperClassName, height = _param.height, width = _param.width, src = _param.src, alt = _param.alt, style = _param.style, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "wrapperClassName",
        "height",
        "width",
        "src",
        "alt",
        "style"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClassName, (_Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container)),
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            display: "inline-block",
            color: "transparent"
        }, style), {
            height: height,
            width: width
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Img_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadeIn)),
            loading: "lazy",
            src: src,
            alt: alt,
            height: height,
            width: width
        }, props))
    });
};
Img.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    wrapperClassName: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().number),
    src: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Img);


/***/ }),

/***/ 8160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10966);
/* harmony import */ var _Hero_HeroButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61522);
/* harmony import */ var _components_Img__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17876);
/* harmony import */ var _components_Section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50943);
/* harmony import */ var _CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95644);
/* harmony import */ var _CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var TalentCta = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_5__/* .SectionContainer */ .S, {
        type: _components_Section__WEBPACK_IMPORTED_MODULE_5__/* .SectionContainer.Type.LIGHTBLUE */ .S.Type.LIGHTBLUE,
        className: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().talentCta),
        anchor: "talentcta",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Section__WEBPACK_IMPORTED_MODULE_5__/* .Section */ .$, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_components_Section__WEBPACK_IMPORTED_MODULE_5__/* .Section.Styles.innerContainerSection */ .$.Styles.innerContainerSection, className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box), (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Img__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: "/img/need-talent@2x.webp",
                        alt: "image",
                        className: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageItem),
                        wrapperClassName: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageContainer)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().textContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                element: "h2",
                                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.SUBHEADLINE_LARGE */ .Z.Size.SUBHEADLINE_LARGE,
                                className: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ctaHeadline),
                                children: "Choose When and How You Work"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                element: "p",
                                className: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ctaDescription),
                                children: "Join thousands of talents who work with Hire Digital to\n                      find the best roles in marketing, design, and software development."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Hero_HeroButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: _Hero_HeroButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Type.BLUE */ .Z.Type.BLUE,
                                className: (_CallToAction_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnApply),
                                title: "Work with Talent",
                                href: "/talent/register",
                                children: "Apply As a Talent"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TalentCta);


/***/ }),

/***/ 53068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Img_fadeIn__2th1r","container":"Img_container__MfUcM","image":"Img_image__C4ftI"};

/***/ }),

/***/ 95644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CallToAction_container__y3aLI","whiteTop":"CallToAction_whiteTop__6CaDC","imageContainer":"CallToAction_imageContainer__zAT7L","image":"CallToAction_image__jIw82","imageItem":"CallToAction_imageItem__ARVSn","talent":"CallToAction_talent__Q67JD","companyDescription":"CallToAction_companyDescription__2svjE","careerDescription":"CallToAction_careerDescription__aKMhA","box":"CallToAction_box__DutGG","small":"CallToAction_small__qLoPV","textContainer":"CallToAction_textContainer__TAmkA","buttons":"CallToAction_buttons__nzjrz","btnApply":"CallToAction_btnApply__qAiFZ","wrapper":"CallToAction_wrapper__ynB62","bgTalent":"CallToAction_bgTalent__Ht_22","bgPlant":"CallToAction_bgPlant__qzCZy","ctaHeadline":"CallToAction_ctaHeadline__YRjvp","ctaDescription":"CallToAction_ctaDescription__7Npth","talentCta":"CallToAction_talentCta__YCVvo","careersLink":"CallToAction_careersLink__66__O"};

/***/ })

}]);